<template>
  <div class="shipment__item__content">
    <div class="shipment__item_image">
      <SfImage
          :alt="cartGetters.getItemName(shipmentItem)"
          :src="cartGetters.getItemImage(shipmentItem)"
          height="130"
          width="130"
      />
    </div>
    <div class="shipment__item_content">
      <div class="shipmentItem-title">
        {{ cartGetters.getItemName(shipmentItem) }}
      </div>
      <!-- <div class="shipmentItem-sku">{{ cartGetters.getItemSku(shipmentItem) }}</div>-->
      <div class="shipment__item_price unit">
        <span class="label">{{ $t('Unit price ') }} : </span>
        <SfPrice
            :regular="
                $n(cartGetters.getItemPrice(shipmentItem).regular, 'currency')
              "
            :special="
                cartGetters.getItemPrice(shipmentItem).special &&
                $n(cartGetters.getItemPrice(shipmentItem).special, 'currency')
              "
            class="shipmentItem-price"
        />
      </div>
      <div class="shipment__item_options">
        <div
            v-for="(value, key) in cartGetters.getItemAttributes(shipmentItem, cartGetters.getItemConfigurableAttribute(shipmentItem))"
            :key="key"
            class="shipment__item_option">
          <div v-if="value" class="option">
            <span class="label">{{ value.label }}</span> :
            <span class="value">{{ value.value }}</span>
          </div>
        </div>
      </div>
      <div class="shipment__item_quantity">
            <span class="label">{{ $t('Quantity') }} : </span
            >{{ cartGetters.getItemQty(shipmentItem) }}
      </div>

      <div class="shipment__item_price total">
        <span class="label">{{ $t('Total price ') }} : </span>
        <SfPrice
            :regular="
                $n(
                  cartGetters.getItemPrice(shipmentItem).regular *
                    cartGetters.getItemQty(shipmentItem),
                  'currency'
                )
              "
            class="shipmentItem-price"
        />
      </div>
    </div>
  </div>

</template>

<script>
import {
  SfDivider,
  SfImage,
  SfPrice,
  SfProperty,
  SfHeading,
  SfTable,
  SfCheckbox,
  SfButton,
  SfRadio
} from '@storefront-ui/vue';


export default {
  name: 'ShipmentItem',

  components: {
    SfDivider,
    SfImage,
    SfPrice,
    SfProperty,
    SfButton,
    SfRadio,
    SfHeading,
    SfTable,
    SfCheckbox
  },

  props: {
    shipmentItem: {}
  },

  setup() {
    return {
      cartGetters
    };
  }
};
</script>

<style lang="scss" scoped>
.shipment {
  &__item {
    &__content {
      display: flex;
      flex-wrap: wrap;
    }

    &_options {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

    }

    &_option {
      margin-right: 5px;

      &:last-of-type {
        margin-right: 0;
      }

      .option {
        display: inline-block;
        font-size: var(--font-size--sm);

        .label {
          display: inline-block;
          color: var(--_c-trinitas-secondary);
        }

        .value {
          font-weight: bold;
        }

      }
    }

    &_content {

      padding-left: var(--spacer-base);
    }

    .shipmentItem {
      &-title {
        font-weight: bold;
      }

    }

    &_price {
      display: flex;
      align-items: flex-end;

      span[class^="sf-price__"] {
        margin-left: 5px;
        font-size: var(--font-size--base);
        font-weight: bold;
      }

      &.total {
        margin-right: 0;
        margin-left: auto;
      }

      &.unit {
        font-size: var(--font-size--sm);

        span[class^="sf-price__"] {
          font-size: var(--font-size--sm);
        }
      }
    }
  }

}

</style>
